import { createContext } from "react";

const TiposAdministracionContext = createContext();

export default TiposAdministracionContext;
